import React from 'react';
import PropTypes from 'prop-types';
import { PATTERNS } from '../../../../../constants/validations';

import styles from './styles.module.styl';

const escapeRegExp = str => str.replace(PATTERNS.REGEXP_SPECIAL_CHARS, '\\$&');

const OptionLabel = (option, props) => {
  const { inputValue } = props;

  if (!inputValue) return option.label;

  const pattern = escapeRegExp(inputValue);
  const regex = new RegExp(`(${pattern})`, 'ig');

  const parts = option.label.split(regex);

  return (
    <span>
      {parts.map((part, index) => {
        const key = `${part}-${option.value}-${index}`;

        if (part.toLowerCase() === inputValue.toLowerCase()) {
          return (
            <span key={key} className={styles.highlighted}>
              {part}
            </span>
          );
        }
        return <span key={key}>{part}</span>;
      })}
    </span>
  );
};

OptionLabel.propTypes = {
  inputValue: PropTypes.string,
};

export default OptionLabel;



// WEBPACK FOOTER //
// ./src/components/common/AsyncPaginatedSelect/components/OptionLabel/index.jsx